import Data from './data';
import Word from './words';
import Results from './results';

export default class State {
  constructor() {
    window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    this.recognition = new SpeechRecognition();
    this.recognition.lang = 'en-Us';
    this.speak = false;
    this.levelBox = document.querySelector('.levels-wrapper');
    this.wordWrapper = document.querySelector('.word-items');
    this.word = document.querySelector('.word-wrapper');
    this.image = document.querySelector('.img');
    this.translation = document.querySelector('.translation');
    this.buttonsFunc = document.querySelector('.buttons');
    this.url = 'https://raw.githubusercontent.com/irinainina/rslang/rslang-data/data/';
    this.currentWord = [];
    this.grammar = null;
    this.score = document.querySelector('.score');
    this.results = 0;
    this.resultsCards = null;
  }

  callEvents() {
    this.wordWrapper.addEventListener('click', (e) => this.changeImage(e));
    this.wordWrapper.addEventListener('click', (e) => this.setTranslation(e));
    this.wordWrapper.addEventListener('click', (e) => this.playAudio(e));
    this.buttonsFunc.addEventListener('click', (e) => this.repeatAudio(e));
    this.levelBox.addEventListener('click', (e) => this.changeLevel(e));
    this.buttonsFunc.addEventListener('click', (e) => this.onSpeak(e));
    this.buttonsFunc.addEventListener('click', (e) => this.onResults(e));
    this.recognition.addEventListener('result', (e) => this.recognizeWord(e));
    this.recognition.addEventListener('end', () => {
      if (this.speak && this.results < 10) {
        this.recognition.start();
      } else {
        this.recognition.stop();
      }
    });
  }

  recognizeWord(e) {
    this.setRecognitionGrammarList();
    this.recognition.maxAlternatives = 10;
    const transcript = Array.from(e.results)
      .map((result) => result[0])
      .map((result) => result.transcript)
      .join(' ')
      .toLocaleLowerCase();
    this.translation.textContent = transcript;
    [...document.querySelectorAll('.word-eng')].forEach((el) => {
      if (el.textContent === this.translation.textContent) {
        el.parentElement.classList.add('word-wrapper--active');
        const like = document.createElement('div');
        like.classList.add('like');
        this.score.append(like);
        this.results += 1;
        const result = new Results();
        result.changeCard();
      }
    });
  }


  changeImage(e) {
    if (e.target.closest('.word-wrapper') && !this.speak) {
      const src = e.target.closest('.word-wrapper').getAttribute('data-image');
      this.image.src = `https://raw.githubusercontent.com/irinainina/rslang/rslang-data/data/${src}`;
    }
  }

  async setTranslation(e) {
    const data = new Data();
    if (e.target.closest('.word-wrapper')) {
      const word = e.target.closest('.word-wrapper').firstChild.innerText;
      const translation = await data.getTranslation(word);
      if (!this.speak) {
        this.translation.innerText = await translation;
      }
    }
  }

  playAudio(e) {
    if (e.target.closest('.word-wrapper') && !this.speak) {
      const srcAudio = `${this.url}${e.target.closest('.word-wrapper').getAttribute('data-audio')}`;
      const audio = new Audio(srcAudio);
      audio.play();
      this.currentWord.pop();
      this.currentWord.push(srcAudio);
    }
  }

  repeatAudio(e) {
    if (e.target.classList.contains('btn-repeat') && !this.speak) {
      const audio = new Audio(this.currentWord[0]);
      audio.play();
    }
  }

  async changeLevel(e) {
    if (e.target.classList.contains('lev')) {
      if (document.querySelector('.results-wrapper')) {
        document.querySelectorAll('.results-wrapper').forEach((el) => {
          el.remove();
        });
      }
      State.setActiveClass(e);
      const level = e.target.innerText;
      this.wordWrapper.innerHTML = '';
      const words = new Word();
      await words.renderWord(level - 1);
      const result = new Results();
      result.renderResults();
    }
  }

  getGrammar() {
    const grammar = [];
    [...document.querySelectorAll('.word-eng')].forEach((el) => {
      grammar.push(el.textContent);
    });
    this.grammar = grammar.join(' | ');
  }

  static setActiveClass(e) {
    document.querySelectorAll('.lev').forEach((el) => {
      el.classList.remove('level-active');
    });
    e.target.classList.add('level-active');
  }

  setRecognitionGrammarList() {
    this.getGrammar();
    const speechRecognitionList = new webkitSpeechGrammarList();
    speechRecognitionList.addFromString(this.grammar, 1);
    this.recognition.grammars = speechRecognitionList;
  }

  onResults(e) {
    if (e.target.classList.contains('result')) {
      if (document.querySelector('.results.wrapper')) {
        document.querySelector('.results.wrapper').remove();
      }
      document.querySelector('.results-wrapper').classList.remove('result-hidden');
      this.addBlur();
    }
  }

  addBlur() {
    document.querySelector('.levels-wrapper').classList.add('blur-active');
    document.querySelector('.image').classList.add('blur-active');
    document.querySelector('.word-items').classList.add('blur-active');
    document.querySelector('.buttons').classList.add('blur-active');
  }

  onSpeak(e) {
    if (e.target.classList.contains('btn-speak')) {
      if (!this.speak) {
        const word = new Word();
        this.resultsCards = word.resultsCards;
        this.results = 0;
        this.recognition.start();
        e.target.classList.add('btn-active');
        this.translation.textContent = '';
        this.translation.classList.add('transl-active');
        this.speak = true;
      } else {
        this.translation.classList.remove('transl-active');
        e.target.classList.remove('btn-active');
        this.recognition.stop();
        this.speak = false;
        [...document.querySelectorAll('.like')].forEach((el) => {
          el.remove();
        });
        [...document.querySelectorAll('.word-wrapper--active')].forEach((el) => {
          el.classList.remove('word-wrapper--active');
        });
      }
    }
  }
}
